
// AI Directives must be set in the detailPage
const aiDirective = (
   type : any,
   docQueryService: DocumentQueryService,
   aiDocService: AIDocumentService,
   templateUrl:any,
   updateCallback: any,
   translationService: TranslationService,
   broadcastTypes: any,
) => ({
   replace: true,
   templateUrl,
   require: '^^detailPage',

   scope: {
      aiDoc: '=',
      fieldSearch: '&',
      openClickTrackLink: '&'
   },

   link(scope: any) {
      scope.searchAIDocs = docQueryService.searchAIDocs
      scope.i18n = translationService
      scope.loaded = true
      scope.hideDirective = false

      // turn off loading indicator when an API response (success/failure) is received
      const turnOffSpinner = (evt: any, msg: any) => {
         if (!aiDocService.isAIDocument(scope.aiDoc) || !msg.types.includes(broadcastTypes.other)) { return }
         scope.loaded = true
         return scope.hideDirective || (scope.hideDirective = evt.name === 'apiError') // don't overwrite if already set to true
      }
      scope.$on('apiSuccess', turnOffSpinner)
      scope.$on('apiError', turnOffSpinner)

      const newDocQueryService = () => {
         if (aiDocService.isAIDocument(scope.aiDoc)) {
            scope.hideDirective = false
            scope.loaded = false
            updateCallback(scope)
         } else {
            scope.hideDirective = true
         }
      }

      const updateDocQueryService = () => {
         scope.hideDirective = false
         if (scope.aiDoc == null) {
            scope.hideDirective = true
            return
         }

         if (aiDocService.isAIDocument(scope.aiDoc)) {
            scope.aiDocs = aiDocService.sortAIDocs(scope.aiDoc, docQueryService.data.aiDocuments[scope.aiDoc.id])
            updateCallback(scope)
         } else {
            return scope.hideDirective = true
         }
      }
      // @ts-ignore
      docQueryService.on('new', type, newDocQueryService)
      // @ts-ignore
      docQueryService.on('update', type, updateDocQueryService)

      return scope.$on('$destroy', () => {
         // @ts-ignore
         docQueryService.off('new', type)
         // @ts-ignore
         return docQueryService.off('update', type)
      })
   }
})

const AIAvailability = (docQueryService: DocumentQueryService, aiDocService: AIDocumentService, translationService: TranslationService, $broadcastTypes: any) => {
   const availabilityUpdate = (scope: any) => {
      scope.i18n = translationService
      // Translate the content type once here (like linkText below) instead of inside the
      // template. Evaluating translate() in a binding on the direct page-load/refresh path
      // interacts badly with the availability spinner; computing it in the update callback
      // keeps it a plain, stable scope value. CDI French-translation fix.
      scope.contentTypeLabel = (scope.aiDoc && scope.aiDoc.content_type)
         ? translationService.translate(scope.aiDoc.content_type)
         : ''
      if (scope.aiDocs && scope.aiDocs.length > 0) {
         return scope.linkText = aiDocService.isPrint(scope.aiDocs[0]) === 0 ?
            translationService.translations.AVAILABLE_IN_PRINT
            :
            translationService.translations.AVAILABLE_ONLINE
      }
   }

   return aiDirective('aiAvailability', docQueryService, aiDocService, '/assets/aiAvailability.html', availabilityUpdate, translationService, $broadcastTypes)
}

const AIButtons = (docQueryService: DocumentQueryService, aiDocService: AIDocumentService, translationService: TranslationService, $broadcastTypes: any) => {
   const buttonUpdate = (scope: any) => {
      scope.aiButtons = aiDocService.getAIButtonValues(scope.aiDoc, scope.aiDocs)
      if (!(scope.aiButtons.primary.link || scope.aiButtons.secondary.link)) {
         return scope.hideDirective = true
      }
   }

   return aiDirective('aiButtons', docQueryService, aiDocService, '/assets/aiButtons.html', buttonUpdate, translationService, $broadcastTypes)
}

const AIDocuments = (docQueryService: DocumentQueryService, aiDocService: AIDocumentService, translationService: TranslationService, $broadcastTypes: any) => {
   const setLinkText = (doc: any) => doc.linkText = aiDocService.isPrint(doc) === 0 ?
      translationService.translations.AVAILABLE_IN_PRINT
      :
      translationService.translations.AVAILABLE_ONLINE

   const docsUpdate = (scope: any) => {
      if (!scope.aiDocs || scope.aiDocs.length === 0) {
         scope.hideDirective = true
         return
      }
      scope.aiDocs.forEach((doc: any) => {
         setLinkText(doc);
         doc.peer_documents.forEach((peer: any) => setLinkText(peer));
      });
   }

   return aiDirective('aiDocuments', docQueryService, aiDocService, '/assets/aiDocuments.html', docsUpdate, translationService, $broadcastTypes)
}

const OtherSources = (linkService: LinkService, aiDocService:AIDocumentService, translationService: TranslationService) => ({
   replace: true,
   templateUrl: '/assets/otherSources.html',

   scope: {
      document: '='
   },

   link(scope: any) {
      scope.sources = []
      scope.hideDirective = false
      scope.i18n = translationService

      const updateLinkService = (data = []) => {
         scope.loaded = true
         scope.sources = data
         return scope.hideDirective = !scope.sources.length
      }
      // @ts-ignore
      linkService.on('update', 'otherSources', updateLinkService)

      // load data into directive when document value in the directive scope changes
      scope.$watch('document', (newVal: any, oldVal: any, scope: any) => {
         if (_.isEmpty(newVal)) { return }
         if (aiDocService.isAIDocument(scope.document)) {
            scope.hideDirective = false
            scope.loaded = false
            return linkService.getSources(newVal)
         } else {
            return scope.hideDirective = true
         }
      })
      // @ts-ignore
      return scope.$on('$destroy', () => linkService.off('update', 'otherSources'))
   }
})


angular.module('summonApp.directives')
   .directive('aiAvailability', ['documentQueryService', 'aiDocumentService', 'translationService', '$broadcastTypes', AIAvailability])
   .directive('aiButtons', ['documentQueryService', 'aiDocumentService', 'translationService', '$broadcastTypes', AIButtons])
   .directive('aiDocuments', ['documentQueryService', 'aiDocumentService', 'translationService', '$broadcastTypes', AIDocuments])
   .directive('otherSources', ['linkService', 'aiDocumentService', 'translationService', OtherSources])
